export class UserAuthError extends Error {}

export class ApiError extends Error {}

// For getServerSideProps fetches: a genuine auth failure should still redirect to
// login, but any other error should degrade to null instead of crashing the page.
export const catchNonAuthError = (err: unknown) => {
  if (err instanceof UserAuthError) {
    throw err;
  }
  console.error(err);
  return null;
};
